import { render, staticRenderFns } from "./newJielong.vue?vue&type=template&id=0c3df7e8&scoped=true"
import script from "./newJielong.vue?vue&type=script&lang=ts"
export * from "./newJielong.vue?vue&type=script&lang=ts"
import style0 from "./newJielong.vue?vue&type=style&index=0&id=0c3df7e8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c3df7e8",
  null
  
)

export default component.exports